import { useEffect, useMemo, useRef, useState } from "react";

import { useAppSelector } from "../../../../../../../store/store";

import { cn } from "../../../../../../../utils/cn";
import GetHeroIcon from "../../../../../../../utils/getHeroIcons";

interface ObjectiveMcqQuestionProps {
  options: Record<string, string>;
  updateAnswerKeyHandler: (answerKey: [] | string[]) => void;
  answerKey: string[] | undefined;
}
const ObjectiveMcqQuestion = ({
  options,
  updateAnswerKeyHandler,
  answerKey
}: ObjectiveMcqQuestionProps) => {
  const selectedChoices = answerKey || [];
  const optionRefs = useRef<(HTMLParagraphElement | null)[]>([]);
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    // Calculate max width after rendering
    if (optionRefs.current.length) {
      const widths = optionRefs.current.map((el) => el?.offsetWidth || 0);
      const max = Math.max(...widths);
      setMaxWidth(max);
    }
  }, [optionRefs]);

  return (
    <div className="space-y-3 md:space-y-5">
      {Object.entries(options).map((option, index) => {
        const selected = selectedChoices?.some((el) => el === option[0]);
        return (
          <div
            onClick={() => {
              const newAnswerKey = answerKey
                ? selected
                  ? [...answerKey.filter((el) => el !== option[0])]
                  : [...answerKey, option[0]]
                : [option[0]];
              updateAnswerKeyHandler(newAnswerKey);
            }}
            key={index}
            className={cn(
              "w-full rounded-md p-3 space-x-3 md:space-x-4 border border-border flex items-center cursor-pointer dark:border-zinc-700 transition-colors hover:border-primary/50",
              selected &&
                "bg-primary-light text-primary border-primary dark:bg-zinc-900 dark:border-zinc-200"
            )}
            style={{
              userSelect: "none",
              WebkitUserSelect: "none",
              MozUserSelect: "none"
            }}
          >
            <div
              className={cn(
                "w-5 h-5 md:w-6 md:h-6 min-w-5 md:min-w-6 min-h-5 md:min-h-6 flex-shrink-0 rounded border border-border flex justify-center items-center cursor-pointer",
                selected && "bg-primary"
              )}
            >
              {selected && (
                <GetHeroIcon name="CheckIcon" className="w-4 h-4 text-white" />
              )}
            </div>
            <p
              ref={(el: any) => (optionRefs.current[index] = el)}
              className="text-sm font-normal text-secondary/90 rounded-xl break-words"
              dangerouslySetInnerHTML={{ __html: option[1] }}
              style={{ whiteSpace: "pre-line" }}
            ></p>
          </div>
        );
      })}
    </div>
  );
};

export default ObjectiveMcqQuestion;
